//
export const toastSource = {
    color: {
        primary: 'toast-primary',
        secondary: 'toast-secondary',
        success: 'toast-success',
        warning: 'toast-warning',
        danger: 'toast-danger',
        info: 'toast-info',
        light: 'toast-light',
        dark: 'toast-dark',
    },
    placement: {
        topleft: 'pos-top-left',
        topcenter: 'pos-top-center',
        topright: 'pos-top-right',
        middleleft: 'pos-middle-left',
        middlecenter: 'pos-middle-center',
        middleright: 'pos-middle-right',
        bottomleft: 'pos-bottom-left',
        bottomcenter: 'pos-bottom-center',
        bottomright: 'pos-bottom-right',
    },
};
